export default __webpack_public_path__ + "static/media/1_Intro.b9c43605.mp4";